export const theme = {
  primaryDark: "#373b3e",
  primaryLight: "#f8f9fa",
  primaryHover: "#56b8b7",
  mobile: "576px",
};
